import React, { useEffect } from 'react';
import Animated from 'components/generals/AnimatedComponent';
import pictures from 'assets/images/home/section_7/pictures.png';
import ActionButton from 'components/ui/buttons/action-button';
export default function Home__section__7() {
    return (
        <main className="nv__section nv__section--no-margin   nv__hp__section__7">
            <section className="nv__section__container">
                <section className="section__block">
                    <Animated animation={'animate__fadeInDown animate__delay-1s'}>
                        <h1>¡Oportunidad única!</h1>
                    </Animated>

                    <Animated animation={'animate__fadeInDown animate__delay-4s'}>
                        <p>
                            Actualmente, posemos la tierra, el equipo humano, la maquinaria de
                            vanguardia y los procesos optimizados para garantizar esta producción.
                            La única pieza que necesitamos es la inyección de capital y con tu ayuda
                            estamos seguros de que podemos conseguirlo.
                        </p>
                    </Animated>

                    <Animated animation={'animate__fadeInDown animate__delay-5s'}>
                        <p>
                            <strong>¿Estás listo para que juntos logremos este reto?</strong>
                        </p>
                    </Animated>
                </section>
                <section className="section__block">
                    <div className="picture">
                        <Animated animation={'animate__fadeInRight animate__delay-1s'}>
                            <img src={pictures} alt="pictures" />
                        </Animated>
                    </div>
                </section>

                {/* <section className="buttonsContainer">
                    <Animated animation={'animate__fadeInDown animate__delay-6s'}>
                        <ActionButton
                            text={'¿Deseo apoyar el campo mexicano?'}
                            type="rounded"
                            color="green"
                            onClick={() => {
                                // dispatch(setDisplayModal(true));
                            }}
                        />
                    </Animated>
                    <Animated animation={'animate__fadeInDown animate__delay-6s'}>
                        <ActionButton
                            text={'¿Que benecios obtengo con esta aportación?'}
                            type="rounded"
                            color="green"
                            onClick={() => {
                                // dispatch(setDisplayModal(true));
                            }}
                        />
                    </Animated>
                </section> */}
            </section>
        </main>
    );
}
